<template>
  <div class="relative">
    <div
      v-if="slide?.text"
      class="absolute left-0 top-0 w-full h-full"
      v-html="slide.text"
    />
    <div class="flex" :class="classes" :style="gridWrapStyles">
      <div
        class="w-full"
        :class="{ 'lg:w-1/2': data?.file?.url }"
        :style="{
          height:
            lgAndDown && slide?.height?.mobile ? slide?.height?.mobile : '100%',
        }"
      >
        <UiVideo
          v-if="slide?.file?.media_type?.includes(assetsTypes.video)"
          class="h-full w-full object-cover"
          :src="slide?.file?.url"
          :src-mobile="slide?.fileMobile?.url"
          autoplay
          loop
          muted
          playsinline
        />
        <UiLazyImg
          v-else
          class="h-full w-full"
          :src="slide?.file?.url || ''"
          :src-mobile="slide?.fileMobile?.url || ''"
          :alt="
            slide?.file?.alt ||
            removeHTMLTagFromString(slide?.title || '') ||
            'Image'
          "
          cover
        />
      </div>
      <div
        v-if="data?.file?.url"
        class="w-full lg:w-1/2"
        :class="{ 'max-lg:hidden': !data.bottomMobile }"
      >
        <UiVideo
          v-if="data?.file?.media_type?.includes(assetsTypes.video)"
          class="h-full w-full object-cover"
          :src="data?.file?.url"
          :src-mobile="data?.fileMobile?.url"
          autoplay
          loop
          muted
          playsinline
        />
        <UiLazyImg
          v-else
          class="h-full w-full"
          :src="data?.file?.url || ''"
          :src-mobile="data?.fileMobile?.url || ''"
          :alt="
            data?.file?.alt ||
            removeHTMLTagFromString(slide?.title || '') ||
            'Image'
          "
          cover
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { assetsTypes, BlockSliderContent } from "ecom-types";

const props = defineProps<{ data: BlockSliderContent }>();

const { lgAndUp, lgAndDown } = useAppBreakpoints();

const slide = computed(() => {
  return props.data?.slides?.[0];
});

const gridWrapStyles = computed(() => {
  return {
    backgroundColor: lgAndUp.value
      ? slide.value?.backgroundColor?.hexa || "#000"
      : slide.value?.backgroundColorMobile?.hexa ||
        slide.value?.backgroundColor?.hexa ||
        "#000",
    height: lgAndUp.value ? slide.value?.height?.desktop || "873px" : "",
  };
});

const classes = computed(() => {
  return [
    props.data.rightSide ? "lg:flex-row" : "lg:flex-row-reverse",
    { "max-lg:flex-col": props.data.bottomMobile },
  ];
});
</script>
